import { LoaderFunctionArgs } from 'react-router-dom'
import { getNewsStats } from '../../action'

export const newsLoader = async ( args: LoaderFunctionArgs ) => {

    await getNewsStats( )

}
